var _slicedToArray = require("/Users/euge/Documents/Dev/Code/ronproject/poster-builder-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _require = require("./utils"),
    createWorker = _require.createWorker;

var base64ImageToRGBMatrix = function base64ImageToRGBMatrix(base64, callback) {
  var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var img = new window.Image();

  img.onload = function onImageLoad() {
    var resizeRatio = 1;

    if (opts.size) {
      resizeRatio = opts.size / Math.max(img.width, img.height);
    }

    if (opts.maxSize) {
      if (img.width > opts.maxSize || img.height > opts.maxSize) {
        resizeRatio = opts.maxSize / Math.max(img.width, img.height);
      }
    }

    var canvas = document.createElement("canvas");
    canvas.width = Math.floor(img.width * resizeRatio);
    canvas.height = Math.floor(img.height * resizeRatio);
    var ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

    var _ctx$getImageData = ctx.getImageData(0, 0, ctx.canvas.width, ctx.canvas.height),
        data = _ctx$getImageData.data;

    function workerCode() {
      self.onmessage = function onWorkerJobStarted(message) {
        var data = message.data[0];
        var width = message.data[1];
        var height = message.data[2];
        var result = [];

        for (var y = 0; y < height; y++) {
          result[y] = [];

          for (var x = 0; x < width; x++) {
            result[y][x] = {
              r: data[y * width * 4 + x * 4],
              g: data[y * width * 4 + x * 4 + 1],
              b: data[y * width * 4 + x * 4 + 2],
              a: data[y * width * 4 + x * 4 + 3]
            };
          }
        }

        self.postMessage([result]);
      };
    }

    var worker = createWorker(workerCode);
    var width = canvas.width,
        height = canvas.height;
    worker.postMessage([data, width, height]);

    worker.onmessage = function onWorkerJobCompleted(message) {
      var _message$data = _slicedToArray(message.data, 1),
          result = _message$data[0];

      callback(null, result);
    };
  };

  img.src = base64;
};

module.exports = base64ImageToRGBMatrix;